export default {"src":"/_next/static/media/0x9678e42cebeb63f23197d726b29b1cb20d0064e5.a0fd02d7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};